import { Pipe, PipeTransform } from '@angular/core';

/**
 * Prevents angular app from crashing due to invalid date in Safari and Edge
 * Example: '<div>{{ '2018-12-12 00:01' | newDate | date }}</div>'
 */
@Pipe({ name: 'newDate' })
export class NewDatePipe implements PipeTransform {
  public transform(date: any): Date {
    return date
      ? new Date(date).toString() !== 'Invalid Date'
        ? new Date(date)
        : new Date(this.formatDate(date))
      : new Date();
  }

  public formatDate(date: string): string {
    return date.toString().replace(/-/g, '/');
  }
}
